import Project from "./project"

export default interface ClientProjectFinance {
    projectId: string
    fiscalPeriod: number
    plannedAmount: number
    actualAmount?: number
    forecastAmount: number
    createdById: string
    updatedById?: string | null
    createdAt?: Date
    updatedAt?: Date

    project?: Project
}


export class ClientProjectFinanceUI {
    static varianceColor(variance: any): string {
        if (variance >= 0)
            return 'success'

        if (variance < 0)
            return 'error'


        return ''
    }
}